import RelationsBlock from './RelationsBlock'

export default RelationsBlock
